import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.pagenation');
import { OnInit, OnChanges, SimpleChanges, Input } from '@angular/core';

@Component({
    selector: 'wiz-component-pagenation',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.pagenation/view.scss */
/* src/app/component.pagenation/view.scss: no such file or directory */`],
})
export class ComponentPagenationComponent implements OnInit, OnChanges {

    @Input() page: number = 1;
    @Input() lastPage: number = 1;
    @Input() onPage: (page: number) => Promise<void> | void;

    public pages: number[] = [];

    ngOnInit() {
        this.buildPages();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.page || changes.lastPage) {
            this.buildPages();
        }
    }

    private buildPages() {
        this.pages = [];

        const startPage =
            Math.floor((this.page - 1) / 10) * 10 + 1;

        for (let i = 0; i < 10; i++) {
            const p = startPage + i;
            if (p > this.lastPage) break;
            this.pages.push(p);
        }
    }

    public async goPage(page: number) {
        if (page < 1 || page > this.lastPage) return;
        if (this.page === page) return;

        this.page = page;

        if (typeof this.onPage === 'function') {
            await this.onPage(page);
        }

        this.buildPages();
    }
}

export default ComponentPagenationComponent;